"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleWrapper = exports.StyleSelect = exports.StylePlaceholder = exports.StyleOptionsItem = exports.StyleOptionsContent = exports.StyleOptions = exports.StyleItemName = exports.StyleItemIcon = exports.StyleItemCurrent = exports.StyleContent = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
const StyleWrapper = exports.StyleWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyleWrapper",
  componentId: "sc-lszec0-0"
})(["position:relative;font-size:1.2rem;line-height:1.5em;*::-webkit-scrollbar{width:10px;}*::-webkit-scrollbar-thumb{border-radius:10px;background-color:", ";border:2px solid ", ";}*:hover::-webkit-scrollbar-track{border-radius:10px;background-color:#ddd;}*:hover::-webkit-scrollbar-thumb{border-color:#ddd;}"], (0, _color.default)('gray-3'), (0, _color.default)('gray-4'));
const StyleSelect = exports.StyleSelect = _styledComponents.default.select.withConfig({
  displayName: "StyleSelect",
  componentId: "sc-lszec0-1"
})(["position:absolute;opacity:0;width:1px;height:1px;"]);
const StyleContent = exports.StyleContent = _styledComponents.default.div.withConfig({
  displayName: "StyleContent",
  componentId: "sc-lszec0-2"
})(["border:2px solid;padding:7px 16px 5px;border-color:", ";border-radius:8px;background-color:", ";color:", ";cursor:default;font-size:1.2rem;line-height:1.5em;position:relative;width:", ";white-space:nowrap;"], (0, _color.default)('gray-4'), (0, _color.default)('white'), (0, _color.default)('gray-3'), _ref => {
  let {
    width
  } = _ref;
  return width;
});
const StylePlaceholder = exports.StylePlaceholder = _styledComponents.default.span.withConfig({
  displayName: "StylePlaceholder",
  componentId: "sc-lszec0-3"
})(["position:absolute;left:0;top:50%;transform:translate(5px,-50%);margin-top:1px;padding:0 12px;background-color:", ";color:", ";transition:top 0.3s,margin-top 0.3s,transform 0.3s,color 0.3s;will-change:top,margin-top,transform;"], (0, _color.default)('white'), (0, _color.default)('gray-3'));
const StyleItemCurrent = exports.StyleItemCurrent = _styledComponents.default.div.withConfig({
  displayName: "StyleItemCurrent",
  componentId: "sc-lszec0-4"
})(["color:", ";transition:color 0.3s;display:flex;justify-content:space-between;align-items:center;transform:translateY(1px);"], (0, _color.default)('gray-3'));
const StyleItemName = exports.StyleItemName = _styledComponents.default.div.withConfig({
  displayName: "StyleItemName",
  componentId: "sc-lszec0-5"
})(["flex:1;overflow:hidden;text-overflow:ellipsis;"]);
const StyleItemIcon = exports.StyleItemIcon = _styledComponents.default.svg.withConfig({
  displayName: "StyleItemIcon",
  componentId: "sc-lszec0-6"
})(["width:24px;height:24px;fill:", ";transform:translateY(-1px);margin-left:16px;"], (0, _color.default)('gray-3'));
const StyleOptions = exports.StyleOptions = _styledComponents.default.div.withConfig({
  displayName: "StyleOptions",
  componentId: "sc-lszec0-7"
})(["position:absolute;left:-2px;top:-2px;min-width:calc(100% + 4px);background-color:", ";padding:12px;border-radius:0 0 8px 8px;transform-origin:top;transform:", ";pointer-events:", ";opacity:", ";will-change:transform,opacity;transition:transform 0.3s,opacity 0.3s;z-index:2;"], (0, _color.default)('gray-4'), _ref2 => {
  let {
    open
  } = _ref2;
  return open ? 'rotateX(0deg)' : 'rotateX(-90deg)';
}, _ref3 => {
  let {
    open
  } = _ref3;
  return open ? 'all' : 'none';
}, _ref4 => {
  let {
    open
  } = _ref4;
  return open ? 1 : 0;
});
const StyleOptionsContent = exports.StyleOptionsContent = _styledComponents.default.div.withConfig({
  displayName: "StyleOptionsContent",
  componentId: "sc-lszec0-8"
})(["overflow:auto;max-height:", ";"], _ref5 => {
  let {
    maxItems
  } = _ref5;
  return "".concat(2.8 * maxItems + 0.2, "em");
});
const StyleOptionsItem = exports.StyleOptionsItem = _styledComponents.default.div.withConfig({
  displayName: "StyleOptionsItem",
  componentId: "sc-lszec0-9"
})(["color:", ";border-radius:8px;padding:8px 12px;font-weight:500;transition:background-color 0.3s;&:hover{background-color:", "}"], (0, _color.default)('gray'), (0, _color.default)('white'));